export default __webpack_public_path__ + "static/media/lib-1.96c5fab0.jpg";